import { render } from "./siloSelect.vue?vue&type=template&id=3babfae6"
import script from "./siloSelect.vue?vue&type=script&lang=js"
export * from "./siloSelect.vue?vue&type=script&lang=js"

import "./siloSelect.vue?vue&type=style&index=0&id=3babfae6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__